
export const REACT_APP_DB_PROJECT_URL = process.env.REACT_APP_DB_PROJECT_URL;
export const REACT_APP_DB_API_KEY= process.env.REACT_APP_DB_API_KEY;